import { render, staticRenderFns } from "./jiqi.vue?vue&type=template&id=a58616d2&"
import script from "./jiqi.vue?vue&type=script&lang=ts&"
export * from "./jiqi.vue?vue&type=script&lang=ts&"
import style0 from "./jiqi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports